interface PersonContactCardData {
  firstName: string;
  lastName: string;
  email?: string | null;
  phone?: string | null;
  companyName?: string | null;
}

function escapeVCardValue(value: string) {
  return value
    .replace(/\\/g, "\\\\")
    .replace(/\n/g, "\\n")
    .replace(/,/g, "\\,")
    .replace(/;/g, "\\;");
}

function sanitizeFilenamePart(value: string) {
  return value
    .trim()
    .replace(/[^a-zA-Z0-9-_]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function buildPersonVCard({
  firstName,
  lastName,
  email,
  phone,
  companyName,
}: PersonContactCardData) {
  const lines = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    `N:${escapeVCardValue(lastName)};${escapeVCardValue(firstName)};;;`,
    `FN:${escapeVCardValue(`${firstName} ${lastName}`.trim())}`,
  ];

  if (companyName) {
    lines.push(`ORG:${escapeVCardValue(companyName)}`);
  }
  if (phone) {
    lines.push(`TEL;TYPE=CELL:${escapeVCardValue(phone)}`);
  }
  if (email) {
    lines.push(`EMAIL;TYPE=INTERNET:${escapeVCardValue(email)}`);
  }

  lines.push("END:VCARD");

  return `${lines.join("\r\n")}\r\n`;
}

export function downloadPersonVCard(data: PersonContactCardData) {
  const vcard = buildPersonVCard(data);
  const blob = new Blob([vcard], {
    type: "text/vcard;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const first = sanitizeFilenamePart(data.firstName);
  const last = sanitizeFilenamePart(data.lastName);
  const baseName = [first, last].filter(Boolean).join("-") || "contact";

  link.href = url;
  link.download = `${baseName}.vcf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
